<template>
  <svg
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 100 100"
  >
    <g>
      <path d="M50.9,37.7c0.7-0.7,0.7-1.9,0-2.6L36.6,20.7c-0.7-0.7-1.9-0.7-2.6,0L19.7,35.1c-0.7,0.7-0.7,1.9,0,2.6 l2.6,2.6c0.7,0.7,1.9,0.7,2.6,0l4.5-4.5c0.7-0.7,2.1-0.2,2.1,0.9v26.4c0,1,0.9,1.9,1.9,1.9h3.7c1,0,1.9-1,1.9-1.9V36.7 c0-1.1,1.4-1.6,2.1-0.9l4.5,4.5c0.7,0.7,1.9,0.7,2.6,0C48.2,40.3,50.9,37.7,50.9,37.7z M78.3,62.6l-2.6-2.5c-0.7-0.7-1.9-0.7-2.6,0 l-4.5,4.5c-0.7,0.7-2.1,0.2-2.1-0.9V37.1c0-1-0.9-1.9-1.9-1.9h-3.7c-1,0-1.9,1-1.9,1.9v26.4c0,1.1-1.4,1.6-2.1,0.9l-4.5-4.5 c-0.7-0.7-1.9-0.7-2.6,0l-2.6,2.7c-0.7,0.7-0.7,1.9,0,2.6l14.3,14.3c0.7,0.7,1.9,0.7,2.6,0l14.3-14.3 C79.1,64.5,79.1,63.2,78.3,62.6z" />
    </g>
  </svg>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class WcIconDataTransfer extends Vue {
  @Prop({ default: '#09121F' }) color!: string
  @Prop({ default: '24' }) height!: string
  @Prop({ default: '24' }) width!: string
}
</script>

<style scoped>

</style>
